export const UI_OPEN_CONFIRMATION_MODAL = "UI/CONFIRMATION_MODAL/OPEN";
export const UI_CLOSE_CONFIRMATION_MODAL = "UI/CONFIRMATION_MODAL/CLOSE";
